/**
 * Normalise AML search API responses for AMLScreening.jsx.
 * Supports watchlist screening and reference-database AML search shapes.
 */

/**
 * @param {object} raw — JSON from amlService (usually { success, data })
 * @param {{ query?: string, searchType?: string, advancedCriteria?: object }} [meta]
 */
export function normalizeAmlSearchResults(raw, meta = {}) {
  const data = raw?.data != null ? raw.data : raw || {}
  const st = meta.searchType || ''
  let persons = data.persons ?? []
  let entities = data.entities ?? []
  if (st === 'entities') {
    entities = data.results ?? entities
  } else if (st === 'persons' || st === 'advanced') {
    persons = data.results ?? persons
  } else {
    persons = data.persons ?? data.results ?? persons
    entities = data.entities ?? entities
  }
  const personsList = Array.isArray(persons) ? persons : []
  const entitiesList = Array.isArray(entities) ? entities : []

  const totalFound =
    data.totalFound ??
    data.total ??
    (personsList.length + entitiesList.length)

  return {
    success: raw?.success !== false,
    query: meta.query ?? data.query ?? (typeof data.query === 'object' ? data.query?.name : '') ?? '',
    totalFound: Number(totalFound) || 0,
    persons: personsList,
    entities: entitiesList,
    executionTime: data.executionTime ?? raw?.executionTime ?? null,
    resultsByCategory: data.resultsByCategory ?? null,
    categoryCounts: data.categoryCounts ?? null,
    provider: data.provider ?? null,
    greenidVerificationId: data.greenidVerificationId ?? null,
    greenidOverallStatus: data.greenidOverallStatus ?? null,
    greenidProfilesMatchedCount: data.greenidProfilesMatchedCount ?? null,
    screeningSummary: data.screeningSummary ?? null,
    searchType: meta.searchType ?? null,
    advancedCriteria: meta.advancedCriteria ?? null,
    entitySearchAvailable: data.entitySearchAvailable
  }
}
